import { useQuery } from "@tanstack/react-query";
import scenarioRepository from "@/repository/scenarioRepository";
import { ScenarioAutocompletesApiData } from "@/model";
import { scenarioQueryKeys } from "./keys";


const getData = async (scenarioId: string) => {
    const { data } = await scenarioRepository.getAutocompletes(scenarioId);
    return data;
};

export const useScenarioAutocompletes = (scenarioId: string) => {
    return useQuery<ScenarioAutocompletesApiData>({
        queryKey: scenarioQueryKeys.autocompletes(scenarioId),
        queryFn: () => getData(scenarioId),
        enabled: !!scenarioId
    });  
};
